import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { isFollow, followDelete, followPost, getFollowList, getFollowerList } from '../service/FollowService';
import { LoginInfo } from '../App';
import { useTranslation } from "react-i18next";
import RegistOrLogin from './RegistOrLogin';
import { Button } from '@mui/material';

const FollowButton = (props) => {
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const location = useLocation()
	const [terms,setTerms] = useState("")

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    const [follow,setFollow] = useState(false)

    useEffect(() => {
        setFollow(props.follow)
    },[props.follow])

    let userId = props.userId
    let userName = props.userName
    let followButton

    if(follow){
        followButton = <Button className='m-1' variant='outlined' color="error" onClick={(e) => {
            e.stopPropagation()
            setOkButtonShow(true)
            dialog("確認",
            <Container className='text-center'>
                {t("common.unfollow")}<br /><br />
                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+userId+".jpg"} style={{width:"100px",height:"auto",borderRadius:"50%"}} /><br />
                {userName}
            </Container>)
        }}><Icon.PersonDash /></Button>
    } else {
        followButton = <Button variant='contained' color="error" onClick={(e) => {
            e.stopPropagation()
            if(loginInfo.result === false){
                dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                return
            }
            if(loginInfo.userId === userId){
                dialog("エラー","自分自身はフォローできません。")
                return
            }
            followPost(userId,dialog).then(r=>{
                if(r){
                    setFollow(true)
                }
            })
        }}>{t("common.followUs")}</Button>
    }
    let okButton = ""
    if(okButtonShow){
        okButton = <Button onClick={() => {
            e.stopPropagation()
            setShow(false)
            followDelete(userId,dialog).then(r=>{
                if(r){
                    setFollow(false)
                }
                setOkButtonShow(false)
            })
        }} >OK</Button>
    }

    return(
        <>{followButton}<Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton}/></>
    )
}

export default FollowButton;
